import { jsx as _jsx } from "react/jsx-runtime";
import { credentialCardColors } from '@sphereon/ui-components.core';
import SSILogo from '../../assets/logos/SSILogo';
import { SSICredentialMiniCardViewContainerStyled as Container, SSICredentialMiniCardViewBackgroundImageStyled as BackgroundImage, } from '../../../styles/components';
const SSICredentialMiniCardView = (props) => {
    const { backgroundColor = credentialCardColors.default, backgroundImage, logo, logoColor, style } = props;
    return (_jsx(Container, { style: { ...style, backgroundColor }, children: _jsx(BackgroundImage, { style: {
                ...(backgroundImage?.uri && { background: `url(${backgroundImage.uri})`, backgroundSize: 'cover' }),
            }, children: (!backgroundImage || logo) &&
                _jsx(SSILogo, { logo: logo, color: logoColor }) }) }));
};
export default SSICredentialMiniCardView;
